const state = {
  paintData: {},
  paintActive: false,
};

const mutations = {
  CHANGE_PAINT_CONTENT(state, paintObj) {
    state.paintData = paintObj;
  },
  CHANGE_PAINT_ACTIVE(state, paintActive) {
    state.paintActive = paintActive;
  },
};

const actions = {
  someAsyncTask({ commit }) {
    // do something async
    commit('TEST');
  },
};

const getters = {
  paintData: (state) => {
    return state.paintData;
  },
  paintActive: (state) => {
    return state.paintActive;
  },
};
export default {
  state,
  mutations,
  actions,
  getters,
};
